import { Stack } from "@mui/material";
import React from "react";
import { SubHeader3 } from "../../atoms/Typography/SubHeader/SubHeader";
import { Text } from "../../atoms/Typography/Text/Text";

const TextGroupType5 = ({  heading, SubText}) => {
  return (
    <Stack gap={"2px"} width={"100%"}>
      <SubHeader3 text={heading} />
      <Text text={SubText} />
    </Stack>
  );
};

export default TextGroupType5;
